"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBannerService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class PaymentMethodsBannerService extends Base_1.BaseService {
    fetchBannerSettings() {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsBannerSettingsApiUrl)(),
            method: 'get',
        });
    }
}
exports.PaymentMethodsBannerService = PaymentMethodsBannerService;
//# sourceMappingURL=index.js.map